var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Rooms:")]),_c('ul',_vm._l((this.rooms),function(room,index){return _c('li',{key:index,class:{
        selected: _vm.selectedRoom ? room.Name == _vm.selectedRoom.Name : false,
        disabled: _vm.disabled
      },on:{"click":function($event){_vm.disabled ? null : _vm.$emit('select', room)}}},[_c('a',[_vm._v(_vm._s(room.Name)+" ("+_vm._s(room.Visible)+":"+_vm._s(room.Invisible)+")")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }